<template>
<v-container>
    <div class="home">
        <h1>
           just wait
        </h1>
<!--
        <p>
            {{user_id}} {{key}}{{app_id}}
        </p>
        <p>{{this.loginusernametbd}}</p>
        <p>{{this.userid}}</p>
        <p>{{this.loginusername}}</p>
        <p>{{this.itemObj}}</p>
--->
    </div>
</v-container>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import VueAxios from "vue-axios";
import apifactory from '../apis/apifactory';
Vue.use(VueAxios, axios);
export default {
    name: "ExtraAuth",
    data: () => ({
        loginusername: null,
        loginusernametbd: null,
        userid: null,
        itemObj: null,

    }),
    props: {
        user_id: {
            type: String,
            required: true,
            default: null
        },
        key: {
            type: String,
            required: true,
            default: null
        },
        app_id: {
            type: String,
            required: true,
            default: null
        }
    },
    mounted() {
        //window.localStorage.clear();
        this.checkauth();
    },
    methods: {
        checkauth() {

            this.getauthdata();
            this.loginusername = "";
            // this.$store.commit("SET_USERNAME", this.loginusername);
            // localStorage.setItem('SET_USERNAME', this.loginusername);

           // localStorage.setItem('SET_USERNAME', this.loginusername);
            //localStorage.setItem('SET_USERID', this.userid);
            //this.loginusernametbd = localStorage.getItem('SET_USERID');
            // this.$router.push("/configuration/brand");
            //this.goTo("/configuration/brand");
        },
        getauthdata() {
            apifactory.userExtraAthenticate(this.user_id, this.key, this.app_id)
                .then((res) => {
                    // alert(res.status);

                    if (res.status != 200) {
                        alert(res.data.message);

                    } else {
                        this.itemObj = res.data;
                        this.loginusername = res.data.username;
                        this.userid = res.data.user_id;
                        localStorage.setItem('SET_USERNAME', this.loginusername);
                        localStorage.setItem('SET_USERID', this.userid);
                        //this.$router.push("/configuration/brand");
                        if(res.data.status >0){
                      
                       this.$router.push("/user");
                        }else
                        {
                            //this.msg=res.data.message;
                               this.$router.push("/noaccess");
                        }
                    }
                })
                .catch(function (error) {
                    console.warn(error);
                });
        },
        goTo(url) {
            return this.$router.push(url);
        }
    }

};
</script>
<style scoped lang="scss">
.cursor__pointer {
  cursor: pointer;
}

.flex-table {
  display: grid;
  grid-template-columns: repeat(auto-fill, 20%);
  grid-template-rows: 100% auto;
  transition: 0.5s;
}

.table-container {
  margin-left: 42px
}

.flex-row {
  display: block;
  width: 100%;
  text-align: left;
  margin-bottom: 20px;
}
.row:first-child {
  color: #505D6F
}

.cell {
  font-size: 14px;
  font-weight: 500;
  color: #505D6F;
  opacity: .6;
  width: 20%;
}

.first {
  width: 20% !important;
  opacity: 1
}

.last {
  width: 200px !important;
  padding-left: 15px
}

.second {
  width: 20% !important;
}

.header {
  font-size: 12px;
  font-weight: 500;
  color: #505D6F
}

.custom-shadow {
  box-shadow: 0px 8px 18px rgba(82, 111, 151, 0.06) !important;
}

.custom-shadow:hover {
  box-shadow: 0px 16px 36px rgba(82, 111, 151, 0.06) !important;
  transform: scale(1.004);
  transition: all 0.2s ease-out;
}

.cursor__pointer {
  cursor: pointer
}
</style>
